<div class="outage-card uncertain" role="alertdialog" aria-modal="true" aria-labelledby="outage-uncertain-title">
  <div class="back-pill" aria-hidden="true">
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"></path></svg>
    <span>{{ copy.uncertainBadge }}</span>
  </div>
  <div class="tile tile-xs warning-tile" aria-hidden="true">
    <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
      <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"></path><path d="M14 3v5h5"></path><path d="M12 12v3"></path><path d="M12 18h.01"></path>
    </svg>
  </div>
  <h2 id="outage-uncertain-title" class="title">{{ copy.uncertainTitle }}</h2>
  <p class="body">{{ copy.uncertainBody }}</p>
  <div class="exit-buttons prompt-buttons">
    <button type="button" class="btn secondary" (click)="onDontSend()">{{ copy.dontSend }}</button>
    <button type="button" class="btn primary" (click)="onSendAgain()">{{ copy.sendAgain }}</button>
  </div>
</div>
